import { FC, PropsWithChildren } from "react";
import { Body } from "capitalrx-components-2.0/lib/typography";
import { BaseProps } from "../../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../../utilities/getHtmlPropsFromBaseProps";
import styles from "./styles.module.scss";

/**
 * The `Instructions` component properties.
 */

export interface InstructionsProps extends BaseProps {
  /**
   * The ID of the component the instructions belong to.
   */
  readonly forId?: string;
}

/**
 * An input component instructions block.
 */
export const Instructions: FC<PropsWithChildren<InstructionsProps>> = (props) => {
  const { children, forId } = props;

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.Instructions, "instructions"],
    testIdPrefix: "instructions",
  });

  if (!children) return null;

  return (
    <Body
      forId={forId ? `${forId}-instructions` : undefined}
      {...getBasePropsFromHtmlProps(baseHtmlProps)}
      inline
      size="mini"
    >
      {children}
    </Body>
  );
};
